<template>
  <b-card no-body class="mt-2 overflow-hidden">
    <template v-if="processing">
      <loader-version2 class="mb-3" />
    </template>
    <template v-else>
      <b-row class="mb-3">
        <b-col cols="12">
          <b-row>
            <!-- Avatar -->
            <b-col cols="12" sm="3">
              <b-row>
                <b-col cols="12" class="avatar mt-4 mb-4">
                  <b-avatar v-if="image" :src="src" size="20rem" />
                  <b-avatar
                    v-else
                    :src="require('@/assets/images/login/avatar.svg')"
                    size="20rem"
                  />
                </b-col>
                <b-col cols="12" class="avatar-information">
                  <b-col class="charge">
                    <img
                      :src="
                        require('@/assets/images/icons/checkbox-circle-line.svg')
                      "
                      alt="worker"
                    />
                    <h4>Trabajador Activo</h4>
                  </b-col>
                  <b-col class="d-flex justify-content-center p-0">
                    <a href="#">
                      Desde
                      {{
                        getAttributeByEmployee("created_at")
                          | moment(getHumanDate)
                      }}
                    </a>
                  </b-col>
                </b-col>
              </b-row>
            </b-col>

            <!-- information -->
            <b-col cols="12" sm="9">
              <b-card-body>
                <b-card-text>
                  <b-form action="#">
                    <b-row>
                      <b-col cols="12" sm="6">
                        <b-form-group cols="6" class="information-input">
                          <label>Nombre completo</label>
                          <b-form-input
                            type="text"
                            placeholder="Nombre completo"
                            class="form-control"
                            :value="getAttributeByEmployee('employee')"
                            disabled
                            readonly
                          />
                        </b-form-group>
                      </b-col>

                      <b-col cols="12" sm="6">
                        <b-form-group cols="6" class="information-input">
                          <label>Sexo</label>
                          <b-form-input
                            type="text"
                            placeholder="Sexo"
                            class="form-control"
                            :value="getAttributeByEmployee('gender')"
                            disabled
                            readonly
                          />
                        </b-form-group>
                      </b-col>

                      <b-col cols="12" sm="6">
                        <b-form-group cols="6" class="information-input">
                          <label>ID</label>
                          <b-form-input
                            type="text"
                            placeholder="ID"
                            class="form-control"
                            disabled
                            :value="getAttributeByEmployee('cc')"
                            readonly
                          />
                        </b-form-group>
                      </b-col>

                      <b-col cols="12" sm="6">
                        <b-form-group cols="6" class="information-input">
                          <label>Edad</label>
                          <b-form-input
                            type="text"
                            placeholder="Edad"
                            class="form-control"
                            :value="getAttributeByEmployee('age')"
                            disabled
                            readonly
                          />
                        </b-form-group>
                      </b-col>

                      <b-col cols="12" sm="6">
                        <b-form-group cols="6" class="information-input">
                          <label>Área</label>
                          <b-form-input
                            type="text"
                            placeholder="Área"
                            class="form-control"
                            :value="getAttributeByEmployee('area')"
                            disabled
                            readonly
                          />
                        </b-form-group>
                      </b-col>

                      <b-col cols="12" sm="6">
                        <b-form-group cols="6" class="information-input">
                          <label>Teléfono</label>
                          <b-form-input
                            type="text"
                            placeholder="Teléfono"
                            class="form-control"
                            :value="getAttributeByEmployee('phone')"
                            disabled
                            readonly
                          />
                        </b-form-group>
                      </b-col>

                      <b-col cols="12" sm="6">
                        <b-form-group cols="6" class="information-input">
                          <label>Cargo</label>
                          <b-form-input
                            type="text"
                            placeholder="Cargo"
                            class="form-control"
                            :value="getAttributeByEmployee('charge')"
                            disabled
                            readonly
                          />
                        </b-form-group>
                      </b-col>

                      <b-col cols="12" sm="6">
                        <b-form-group cols="6" class="information-input">
                          <label>Sindicato</label>
                          <b-form-input
                            type="text"
                            placeholder="Sindicato"
                            class="form-control"
                            :value="getAttributeByEmployee('labor_union')"
                            disabled
                            readonly
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-form>
                </b-card-text>
              </b-card-body>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </template>
  </b-card>
</template>

<script>
import controller from "./controller";
const { script } = controller();
export default script;
</script>

<style lang="scss" scoped src="./styles.scss" />
